var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "section section--spacing-short section--background-tertiary"
    },
    [
      _vm.rawTitle
        ? _c("div", { staticClass: "wrapper" }, [
            _c("div", { staticClass: "container" }, [
              _c(
                "div",
                { staticClass: "small-width" },
                [
                  _c("macro-title", {
                    attrs: {
                      title: _vm.rawTitle,
                      "add-class":
                        "m-slider__title h2 font-weight-bold text-align-center"
                    }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "slider__wrapper" },
        [
          _vm.itemsSlider
            ? _c(
                "swiper",
                {
                  ref: "mySwiper",
                  attrs: { "auto-update": true, options: _vm.swiperOptions }
                },
                _vm._l(_vm.itemsSlider, function(item, key) {
                  return _c(
                    "swiper-slide",
                    {
                      key: "slide-" + key,
                      staticClass: "slider__item",
                      class: [{ "slider__item--has-link": item.link }]
                    },
                    [
                      item.image
                        ? _c(
                            "figure",
                            { staticClass: "figure figure--slider" },
                            [
                              _c("picture", [
                                _c("img", {
                                  staticClass: "swiper-lazy",
                                  attrs: {
                                    "data-src": item.image.data.slider[0],
                                    width: "638",
                                    height: "480",
                                    alt: item.image.data.alt
                                  }
                                })
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.link
                        ? [
                            _c(
                              "a",
                              {
                                staticClass: "slider__item-content",
                                attrs: {
                                  href: item.link.url,
                                  target:
                                    item.link.target === "_blank"
                                      ? "_blank"
                                      : "_self"
                                }
                              },
                              [
                                _c("macro-title", {
                                  attrs: {
                                    title: item.suptitle,
                                    "add-class": "title--small"
                                  }
                                }),
                                _vm._v(" "),
                                _c("macro-title", {
                                  attrs: {
                                    title: item.title,
                                    "add-class":
                                      "h3 slider__item-title font-weight-bold"
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "action action--bordered action--bordered-white"
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "action__text" },
                                      [_vm._v(_vm._s(item.link.title))]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        : [
                            _c(
                              "div",
                              { staticClass: "slider__item-content" },
                              [
                                _c("macro-title", {
                                  attrs: {
                                    title: item.suptitle,
                                    "add-class": "title--small"
                                  }
                                }),
                                _vm._v(" "),
                                _c("macro-title", {
                                  attrs: {
                                    title: item.title,
                                    "add-class": "h3 font-weight-bold"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "swiper-lazy-preloader swiper-lazy-preloader-black"
                      })
                    ],
                    2
                  )
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "slider-navigation" }, [
            _c(
              "button",
              {
                staticClass:
                  "swiper-button-prev slider__button slider__button--prev"
              },
              [
                _c("span", { staticClass: "visually-hidden" }, [_vm._v("←")]),
                _vm._v(" "),
                _c("v-icon-arrow-left", { attrs: { theme: _vm.theme } })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "swiper-button-next slider__button slider__button--next"
              },
              [
                _c("span", { staticClass: "visually-hidden" }, [_vm._v("→")]),
                _vm._v(" "),
                _c("v-icon-arrow-right", { attrs: { theme: _vm.theme } })
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.cleanLink.url
        ? _c(
            "div",
            {
              staticClass:
                "action__container action__container--center m-slider__action"
            },
            [
              _c(
                "a",
                {
                  staticClass: "action action--bordered",
                  attrs: {
                    href: _vm.cleanLink.url,
                    target:
                      _vm.cleanLink.target === "_blank" ? "_blank" : "_self"
                  }
                },
                [
                  _c("span", { staticClass: "action__text" }, [
                    _vm._v(_vm._s(_vm.cleanLink.title))
                  ])
                ]
              )
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }